<template>
  <base-icon-button :key="$vnode.key || title"
                    v-on="$listeners"
                    :title="title">
    <base-material-design-icon v-bind="iconAttrs"
                               icon="send"/>
  </base-icon-button>
</template>

<script>
  import BaseIconButton from '@/components/baseComponents/baseIcons/BaseIconButton';
  import BaseMaterialDesignIcon from '@/components/baseComponents/baseIcons/BaseMaterialDesignIcon';

  export default {
    name: 'BaseIconButtonSend',
    components: { BaseMaterialDesignIcon, BaseIconButton },
    props: {
      iconAttrs: {
        type: Object,
        default: () => ({}),
      },
      title: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped>

</style>
